module.exports = __webpack_public_path__ + "static/img/s2.ae16774.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s2.png
// module id = yDhK
// module chunks = 73